module.exports = __webpack_public_path__ + "static/media/program.ecd9e667.jpg";